import React, { Component } from 'react';
import './logo.css';

class Logo extends Component {
  render = () => (
    <div className="logo">
      <span>Trivia Night</span>
    </div>
  );
}

export default Logo



// WEBPACK FOOTER //
// ./src/components/Logo/index.js